import React from 'react';
import foto2 from '../../assets/foto_2_grid.png';
import './CatalogHero.css';

const CatalogHero = () => {
  return (
    <section className="catalog-hero">
      <div className="catalog-hero-container">
        <div className="catalog-hero-image-wrapper">
          <img src={foto2} alt="Catalog" className="catalog-hero-image" />
          <div className="catalog-hero-overlay"></div>
          <div className="catalog-hero-content">
            <h1 className="catalog-hero-title">CATÁLOGO</h1>
            <p className="catalog-hero-subtitle">Explore todas nossas opções e tamanhos</p>
            <button className="btn btn-catalog">Ver Lançamentos</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CatalogHero;
